import { FC } from 'react';
import styled from 'styled-components';

import { MpBlock } from 'shared/ui/MpBlock';
import { MpLink } from 'shared/ui/MpLink';
import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpText } from 'shared/ui/MpText';
import { MpUl } from 'shared/ui/MpUl';

const HeaderStyled = styled.h2`
	margin-bottom: 24px;
	font-weight: 600;
	font-size: 24px;
`;

export const DenvikTariffsDetails: FC = () => (
	<MpBlock>
		<HeaderStyled>Миграция базы и консультации</HeaderStyled>
		<MpParagraph>
			Миграцию со старой базы можно попробовать провести самостоятельно, либо обратиться за помощью консультанта.
		</MpParagraph>
		<MpText style={{ marginBottom: `12px` }}>Разработчик оказывает консультационные услуги:</MpText>
		<MpUl>
			<li>
				<MpText>Миграция одной базы — 12 000 ₽</MpText>
			</li>
			<li>
				<MpText>Час консультаций — 3 000 ₽</MpText>
			</li>
		</MpUl>
		<MpParagraph>
			Записаться на консультацию можно во время оформления подписки или по почте{` `}
			<MpLink url='mailto:help@denvic.ru' text='help@denvic.ru' />
		</MpParagraph>
	</MpBlock>
);
